// We're using iframe resizer to make the iframe the full height of the content and avoids a double side-bar issue
// That makes it impossible to center the dialog with CSS only. So we do it with some math
import { forceNextTick } from "@/util/force-next-tick";

/**
 * Make sure only one Dialog is present in the page. Use "v-if" if you have more than 1.
 */
export function centerDialogInScreen() {
  // We need to wait for the dialog to fully render
  forceNextTick(() => {
    const parentScrollTop = window.parent.document.documentElement.scrollTop;
    const parentHeight = window.parent.document.documentElement.clientHeight;
    const dialogContentElement = document.querySelector(
      ".v-dialog__content"
    ) as HTMLElement | null;
    const dialogElementHeight = document
      .querySelector(".v-dialog")
      ?.getBoundingClientRect().height;

    if (!dialogElementHeight || !dialogContentElement) return;

    dialogContentElement.style.top = `${parentScrollTop}px`;

    // dialogContentElement.style.top = `${parentScrollTop}px`;
    dialogContentElement.style.height = `${parentHeight - 50}px`;
  });
}
